<template>
  <div  class="name-list">
    <div class="edit-panel">
      <a class="back" @click="backPage">
        <i class="iconfont icon-icon_return" />返回
      </a>
      <span class="title">
        配置选项名称
      </span>
    </div>
   <div class="head">
    <label class="margin24">
      <span class="search-title">搜索服务</span>
      <el-input
      v-model="keyword"
      placeholder="服务名称、version"
      style="width: 280px">
        <template #suffix>
            <i class="el-icon-search el-input__icon">
          </i>
        </template>
      </el-input>
    </label>
    <!-- <label class="margin24">
      <span class="search-title">状态</span>
        <el-select v-model="status" placeholder="请选择">
        <el-option
          v-for="item in statusOptions"
          :key="item.val"
          :label="item.name"
          :value="item.val">
        </el-option>
      </el-select>
    </label> -->
      <el-button class="search"
        type="primary"
        @click="handleFilter"
        @keyup.enter="handleFilter">搜索</el-button>
   </div>
    <el-table
      :data="productList"
      :border="false"
      :header-cell-style="{ background: '#EFF1F4' }"
      :fit="true"
      style="width: 100%"
    >
      <el-table-column
        align="left"
        label="version"
        :width="firstWidth[0]"
      >
        <template #default="scope">
          <span
            >{{ scope.row.version ? scope.row.version : "-" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="服务名称" :width="firstWidth[2]">
        <template #default="scope">
          <span>{{ scope.row.description ? scope.row.description : scope.row.description }} </span>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="状态"
        :width="firstWidth[3]"
      >
        <template #default="scope">
          <span>{{ scope.row.phone ? scope.row.phone : "-" }} </span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="选项名称" :width="firstWidth[4]">
        <template #default="scope">
          <div v-if="!scope.row.showInput">
            <span
              >{{scope.row.alias ? scope.row.alias: "-" }}
            </span>
            <el-button type="text" icon="el-icon-edit" @click="editBtn(scope.$index)"></el-button>
          </div>
            <el-input
              v-model="scope.row.alias"
              v-if="scope.row.showInput"
              @keyup.enter="blurSave(scope.row.alias, scope.row.version, scope.$index)"
              @blur="blurSave(scope.row.alias, scope.row.version, scope.$index)"
              style="width: 280px">
            </el-input>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @current-change="getProductList"
      :page-size="versionPageSize"
      :total="versionTotal"
      layout="total, ->, prev,pager, next"
    >
    </el-pagination>
  </div>
</template>
<script>
import { getProductList, updateAlias } from '../../API/application'
export default ({
  data () {
    return {
      productList: [],
      versionPageSize: 10,
      versionTotal: 1,
      firstWidth: [],
      keyword: null,
      status: null,
      showInput: false,
      statusOptions: [{
        name: '全部',
        val: null
      }, {
        name: '未重命名',
        val: 0
      },
      {
        name: '已重命名',
        val: 1
      }
      ]
    }
  },
  mounted () {
    this.getProductList(1)
  },
  methods: {
    handleFilter () {
      this.getProductList(1)
    },
    async getProductList (versionPageNumber) {
      this.versionPageNumber = versionPageNumber
      var data = {
        pageNum: versionPageNumber,
        pageSize: this.versionPageSize,
        keyword: this.keyword,
        status: this.status
      }
      const res = await getProductList(data)
      this.versionTotal = res.total
      console.log('reeeee-pro', res)
      if (res) {
        this.productList = res.list
      }
    },
    editBtn (index) {
      this.productList[index].showInput = true
    },
    async blurSave (alias, version, index) {
      const res = await updateAlias({
        alias: alias,
        version: version
      })
      console.log('resresres', res)
      if (res === '修改成功') {
        this.productList[index].showInput = false
        this.$message.success('修改成功')
      }
    },
    backPage () {
      this.$router.go(-1)
    }
  }
})
</script>
<style lang="less">
.name-list {
  .head {
    display: flex;
    align-items: center;
    margin: 20px 0;
    .search-title {
      color: #111A2E;
      font-size: 14px;
      margin-right: 12px;
    }
  }
  .select-trigger {
    width: 130px;
  }
  .margin24 {
    margin-right: 24px;
  }
  .back {
    font-size: 16px;
    color: var(--main-text);
    display: flex;
    align-items: center;
    cursor: pointer;
    // margin-bottom: 18px;
    // height: 28px;
    border-right: 1px solid var(--form-line);
    width: 90px;
    i {
      font-size: 28px;
    }
  }
.edit-panel {
  background-color: var(--white);
  border-radius: 1px;
  padding: 20px 0;
  display: flex;
  align-items: center;
  .el-checkbox-button {
    margin-right: 8px;
  }
  .title {
    font-size: 20px;
    color: var(--main-text);
    // margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
    .el-checkbox {
      margin-right: 10px;
    }
  }
}
}

</style>
